var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audit"},[_c('span',{staticClass:"audit__label"},[_vm._v(_vm._s(((_vm.$t("message.analytics.auditMade")) + ":")))]),_c('p',{staticClass:"audit__date"},[_vm._v(_vm._s(_vm.date))])])}
var staticRenderFns = []

export { render, staticRenderFns }